import { FC, ReactNode, useMemo } from 'react';
import { CreateFormStepsContext, CreateFormStepsContextValue } from './context';

interface CreateFormStepsMainProps extends CreateFormStepsContextValue {
  children: ReactNode;
}

const CreateFormStepsMain: FC<CreateFormStepsMainProps> = ({ template, children }) => {
  const value = useMemo<CreateFormStepsContextValue>(() => ({ template }), [template]);

  return <CreateFormStepsContext.Provider value={value}>{children}</CreateFormStepsContext.Provider>;
};

export default CreateFormStepsMain;
